import Image from "next/image";
import { useWebTranslation } from "translations";
import dog from "/public/images/tractive/dog.png";
import cat from "/public/images/tractive/cat.png";
import { SpeciesEnum } from "../../../../../../__generated__/globalTypes";
import { Typography } from "ui-kit/Typography";
import styles from "./QPbanner.module.css";

export const QPBanner = ({ species }: { species: SpeciesEnum | null }) => {
  const { t } = useWebTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.text}>
          <Typography variant="body4" color="sun600">
            <strong>{t("tractive.qp.highlight")}</strong>
          </Typography>
          <Typography variant="body2">
            <strong>{t("tractive.qp.title")} </strong>
          </Typography>
          <Typography variant="body3" color="grey500">
            {t("tractive.qp.description")}
          </Typography>
        </div>
        <Image
          src={species === SpeciesEnum.dog ? dog : cat}
          alt=""
          width={125}
          height={144}
        />
      </div>
      <Typography
        variant="body4"
        color="grey400"
        style={{ lineHeight: 1, marginTop: 8 }}
        component="div"
      >
        {t("tractive.qp.terms")}
      </Typography>
    </div>
  );
};
